import type {
  DashboardRiskAlert,
  DashboardRisksSummary,
} from '@nebalkon-workspace/admin-api';

/** Merges API alerts with derived snapshot alerts (e.g. pending topups). */
export function buildDashboardActionAlerts(
  risks: DashboardRisksSummary | null | undefined,
): DashboardRiskAlert[] {
  if (!risks) {
    return [];
  }

  const alerts = [...risks.alerts];

  if (
    risks.pending_topups_count > 0 &&
    !alerts.some((alert) => alert.type === 'topups_pending')
  ) {
    alerts.push({
      type: 'topups_pending',
      count: risks.pending_topups_count,
      severity: 'medium',
    });
  }

  return alerts;
}

export const DASHBOARD_RISK_ALERT_I18N_PREFIX =
  'STAFF.DASHBOARD.RISKS.ALERT' as const;

export const DASHBOARD_DEBT_AGING_I18N_PREFIX =
  'STAFF.DASHBOARD.RISKS.DEBT_AGING' as const;

export function dashboardRiskAlertLabelKey(type: string): string {
  return `${DASHBOARD_RISK_ALERT_I18N_PREFIX}.${type}`;
}

export function dashboardDebtAgingLabelKey(label: string): string {
  return `${DASHBOARD_DEBT_AGING_I18N_PREFIX}.${label}`;
}
